import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ObservedValueOf } from 'rxjs/internal/types';
import { map } from 'rxjs/operators';
import { CustomerDAO } from '../../../../core/services/dao/customerDAO';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { User } from 'anchor-shared/lib/model/entity/user';
import { AuthService } from '../../../../core/services/auth.service';
import { UploadDAO } from '../../../../core/services/dao/uploadDAO';

@Component({
  selector: 'app-customer-id-upload',
  templateUrl: './customer-id-upload.component.html',
  styleUrls: ['./customer-id-upload.component.scss'],
})
export class CustomerIdUploadComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  templateData$: Observable<{
    user: ObservedValueOf<Observable<User>>;
  }>;
  user: User;

  subs: Subscription[] = [];

  @Input()
  profileUserId: number;

  @Input()
  isAdmin: boolean;

  constructor(
    public customerDAO: CustomerDAO,
    private userDAO: UserDAO,
    private authService: AuthService,
    private uploadDAO: UploadDAO,
  ) {
    this.user = this.userDAO.getCurrentUser();
  }

  ngOnInit() {
    this.setProfileUserId();
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  private initAsyncData(): void {
    if (this.isAdmin) {
      this.templateData$ = this.userDAO.findUserById(this.profileUserId).pipe(
        map((user) => {
          this.user = user;
          return { user };
        }),
      );
    } else {
      this.templateData$ = this.userDAO.findUserById(this.profileUserId).pipe(
        map((user) => {
          this.user = user;
          return { user };
        }),
      );
    }
  }

  private setProfileUserId() {
    if (!this.profileUserId) {
      this.profileUserId = this.user.id;
    }
    this.initAsyncData();
  }
}
